import { ADMINISTRATION, SUPPLIER } from '../common/nav/apps';
import { useContext, useMemo } from 'react';
import { UserContext } from '../common/auth/UserContext';

export default (additionalExpressions = undefined) => {
    const { application } = useContext(UserContext);

    const expressionsByApp = useMemo(() => {
        return {
            [ADMINISTRATION.id]: { expressions: [{ field: 'public', value: { values: ['false'] } }] },
            [SUPPLIER.id]: {
                expressions: [
                    { field: 'public', value: { values: ['false'] } },
                    additionalExpressions ? additionalExpressions : {}
                ]
            }
        };
    }, []);

    return expressionsByApp[application.id];
};
